import React from "react";
import {useTranslation} from "react-i18next";
import {useHistory} from "react-router";
import MenuItem from "../../../components/atoms/menu/menuItem";
import NavbarTitle from "../navbarTitle/navbarTitle";
import {IconSource} from "../../../shared/enums/iconSource";
import {RoutePaths} from "../../../shared/routePaths";
import {Navigation} from "../../../utils/navigation";
import {AuthUser} from "../../../utils/auth/user";
import "./adminMenuSection.sass";

/**
 * The head office section on vertical navigation menu.
 */
const HeadOfficeMenuSection: React.FC = () => {
  const {t} = useTranslation(["translation"]);
  const history = useHistory();

  // Same check as SuperUserRoute so the link only shows for users who can open the page.
  if (!AuthUser.getInstance().IsSuperUser) {
    return null;
  }

  const isOnVillageCalendarsPage = history.location.pathname.startsWith(
    RoutePaths.VillageCalendars
  );
  const manageVillageName = t("translation:titles.manageVillage");

  return (
    <div className="admin-menu-section">
      <NavbarTitle title={t("translation:labels.headOffice")} />
      <div className="admin-menu-options">
        <MenuItem
          title={manageVillageName}
          icon={IconSource.village}
          selected={isOnVillageCalendarsPage}
          scoped={isOnVillageCalendarsPage}
          onClick={() => {
            Navigation.navigateWithSelectedVillageId(
              history,
              RoutePaths.VillageCalendars
            );
          }}
        />
      </div>
    </div>
  );
};

export default HeadOfficeMenuSection;
